import {lazy, filter, set} from './lang.js';
import {doc} from './documentation.js';

doc(
    "acc",
    {
        "parameterName": "The parameter to accumulate",
        "value": "The value added to the accumulator on each trigger",
        "limit": "The value at which the accumulator will reset to 0",
    },
    "Adds an accumulated value to a parameter every trigger, adding the passed-value to the accumulated value. When it reaches the limit, the accumulator resets to 0.");

export const acc = (name, val, limit) => {
    let accumulated = 0;
    return (stepData, stepNumber, time) => {
        if (stepData === undefined) {
            return filter(false);
        }
        let _name = lazy(name, stepData, stepNumber, time);
        let pValue = stepData[_name];
        accumulated += lazy(val, stepData, stepNumber, time);
        if (accumulated > lazy(limit, stepData, stepNumber, time)) {
            accumulated = 0;
        }

        return set(_name, pValue + accumulated);
    };
};

